export default "__VITE_ASSET__Kjo4dtBZ__"